module.exports = __webpack_public_path__ + "media/images/sp/plans/icon3-06052ca9c85bdd52a077757f7374c4e4.svg";